import React from "react";
import {
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Svg,
  Path,
} from "@react-pdf/renderer";
import backgroundGradient from "../images/BG.png";
import logo from "../images/Logo.png";
import waves from "../images/Waves.png";

const CalendarIcon = () => (
  <Svg width="15" height="15" viewBox="0 0 20 20">
    <Path
      d="M5.78947 2C6.02201 2 6.21053 2.18851 6.21053 2.42105V3.68421H13.7895V2.42105C13.7895 2.18851 13.978 2 14.2105 2C14.4431 2 14.6316 2.18851 14.6316 2.42105V3.68421H15.8947C17.0574 3.68421 18 4.62677 18 5.78947V15.8947C18 17.0574 17.0574 18 15.8947 18H4.10526C2.94256 18 2 17.0574 2 15.8947V5.78947C2 4.62677 2.94256 3.68421 4.10526 3.68421H5.36842V2.42105C5.36842 2.18851 5.55693 2 5.78947 2ZM4.10526 4.52632C3.40764 4.52632 2.84211 5.09185 2.84211 5.78947V7.05263H17.1579V5.78947C17.1579 5.09185 16.5924 4.52632 15.8947 4.52632H4.10526ZM17.1579 7.89474H2.84211V15.8947C2.84211 16.5924 3.40764 17.1579 4.10526 17.1579H15.8947C16.5924 17.1579 17.1579 16.5924 17.1579 15.8947V7.89474Z"
      fill="#EBF1FD"
    />
  </Svg>
);

const CoverPage = ({
  title = "Culture Index Results",
  subtitle = "Descriptive analytics report for",
  companyName = "Demo Company",
  date = new Date(),
  anchor,
}) => {
  return (
    <Page style={styles.container}>
      {/* Background Layer */}
      <View style={styles.fullPage}>
        <Image src={backgroundGradient} style={styles.background} />
        <Image src={waves} style={styles.waves} />
      </View>

      {/* Logo */}
      <Image src={logo} style={styles.logo} />

      {/* Text Content */}
      <View style={styles.textContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>
          {subtitle}&nbsp;<Text style={styles.companyName}>{companyName}</Text>
          {anchor && " segmented by "}
          {anchor && <Text style={styles.companyName}>{anchor}</Text>}
        </Text>
        {/* <Text style={styles.date}>{date}</Text> */}
      </View>

      {/* Date container */}
      <View style={styles.dateContainer}>
        <CalendarIcon />
        {/* Format date as Jan 28, 2025 */}

        <Text style={styles.date}>{`${date.toLocaleString("default", {
          month: "short",
        })} ${date.getDate()}, ${date.getFullYear()}`}</Text>
      </View>
    </Page>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundColor: "#2D70E2",
  },
  fullPage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  waves: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "100%",
  },
  logo: {
    position: "absolute",
    top: 40,
    left: 40,
    width: 100,
  },
  textContainer: {
    position: "absolute",
    bottom: 275,
    left: 40,
    right: 40,
    textAlign: "left",
    maxWidth: 330,
  },
  title: {
    fontSize: 82,
    fontFamily: "Outfit",
    fontWeight: 500,
    color: "#fff",
    marginBottom: 10,
    lineHeight: 0.9,
  },
  subtitle: {
    fontSize: 26,
    color: "#fff",
    marginBottom: 10,
    marginTop: 38,
    fontFamily: "Raleway",
    fontWeight: 500,
  },
  companyName: {
    fontSize: 26,
    color: "#fff",
    fontFamily: "Raleway",
    fontWeight: 600,
  },
  date: {
    fontSize: 10,
    color: "#fff",
    marginLeft: 3,
    marginTop: 1,
  },
  // dateContainer should be positioned 100px from the bottom and have a similar margin as the text container
  dateContainer: {
    position: "absolute",
    bottom: 40,
    left: 40,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#fff",
    fontSize: 10,
    fontFamily: "Raleway",
    fontWeight: 600,
  },
});

export default CoverPage;
